export const loadinghtml = `
  <div style="
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  "><img style="
    width: 160px
  " src="/wp-content/themes/academy-theme/assets/icons/loading.gif" /></div>
`

export const errorhtml = `
  <div style="
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  "><img style="
    width: 50px
  " src="/wp-content/themes/academy-theme/assets/icons/error.png" /></div>
`

export const scormplayerhtml = `
  <div class="Player"> 
    <div class="IFrame">
      <iframe class="ScormContainer"></iframe>
    </div>
    <div class="ClosePlayer"></div>
  </div>
`

export const ispringsummaryhtml = `
  <div class="ISpringSummary Visible">
    <div class="Cover">
    </div>
    <div class="Menu">${ __('Menu') }</div>
    <div class="Tree"></div>
  </div>
`

export const ispringnavhtml = (title) => `
  <div class="ISpringNav">
    <div class="Progress">
      <div class="Bar"></div>
    </div>
    <div class="Reload"></div>
    <div class="FullScreen"></div>
    <div class="Prev">${ __('Prev') }</div>
    <div class="Next">${ __('Next') }</div>
  </div>
  <div class="NavToggle">
    <div class="Hamburguer">
      <div class="Bar"></div>
      <div class="Bar"></div>
      <div class="Bar"></div>
    </div>
    <div class="Title">${ title }</div>
  </div>
`